import supabase from "../subabaseClient"

export default async function retrieveSession(login, logout) {
  const {
    data: { session },
    error,
  } = await supabase.auth.getSession()

  if (error) {
    console.error("Error retrieving session:", error.message)
  } else {
    if (session) {
      console.log("Session retrieved successfully!")
      login({
        id: session?.user?.id,
        email: session?.user?.email,
        username: session?.user?.user_metadata?.username,
      })
    } else {
      console.log("No session found!")
      logout()
    }
  }

  return session
}
